import { render, staticRenderFns } from "./LvCard.vue?vue&type=template&id=94ac10d6"
import script from "./LvCard.vue?vue&type=script&lang=js"
export * from "./LvCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports